import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    maxWidth: "1400px",
    margin: "0 auto",
    paddingLeft: "20px",
    paddingRight: "20px",
    boxSizing: "border-box",
    height: "100%",
  },

  filterContainer: {
    display: "flex",
    padding: theme.spacing(4),
    "& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl": {
      backgroundColor: theme.palette.background.white,
    },
  },
  filterShowContainer: {
    display: "flex",
    width: "80%",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "nowrap",
    padding: theme.spacing(4, 0),
    "& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl": {
      backgroundColor: theme.palette.background.white,
    },
  },
  filterViewContainer: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(4),
    "& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl": {
      backgroundColor: theme.palette.background.white,
    },
  },
  topics: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    // padding: theme.spacing(4),
    width: "100%",
    margin: "auto",
  },
  containerBox: {
    boxShadow: "none !important",
    borderRadius: 5,
    height: "fit-content",
    width: "80%",
    margin: "auto",
    zIndex: 1,
    position: "relative",
    marginTop: "-5px",
    "& .MuiPaper-root": {
      boxShadow: "none !important",
    },
  },
  headings: {
    fontWeight: 700,
    fontSize: 20,
    paddingTop: theme.spacing(4),
    whiteSpace: "nowrap",
  },
  headingTitle: {
    color: theme.palette.Primary.background,
    fontWeight: 600,
  },
  button: {
    width: "100%",
    backgroundColor: `${theme.palette.Primary.background}!important`,
    fontStyle: "normal",
    fontWeight: "600!important",
    fontSize: "13px!important",
    textTransform: "capitalize",
  },
  buttonSecondary: {
    color: theme.palette.Primary.background,
    borderColor: theme.palette.Primary.background,
    "&:hover": {
      borderColor: theme.palette.Primary.background,
      backgroundColor: theme.palette.Primary.contrastText,
      border: "2px solid",
    },
    marginRight: theme.spacing(5),
  },
  tabs: {
    zIndex: 1,
    position: "relative",
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.login.loginButton,
      display: "none",
    },
    "& .MuiTabs-flexContainer": {
      width: "85%",
      margin: "auto",
      display: "flex",
      justifyContent: "space-between",
      position: "relative",
      zIndex: 2,
      borderRadius: 5,
      backgroundColor: "#E0E0E0",
      borderTop: "1px solid #5A404E",
      borderLeft: "1px solid #5A404E",
      borderRight: "1px solid #5A404E",
      "@media screen and (min-width: 1920px) and (min-height: 563px)": {
        width: "60% !important",
      },
    },
    "& .MuiTab-root": {
      color: theme.palette.text.primary,
    },
    "& .MuiTab-root.Mui-selected": {
      color: `${theme.palette.login.loginButton} !important`,
    },
  },
  tabOption: {
    textTransform: "capitalize",
    fontWeight: 700,
    fontSize: 24,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  },
  mainTitle: {
    padding: 0,
    margin: theme.spacing(0, 0, 10, 20),
  },
  headingText: {
    position: "relative",
  },
  underline: {
    position: "absolute",
    bottom: theme.spacing(-2),
    left: 0,
    width: "100%",
    height: 1,
    background:
      "linear-gradient(90deg, #FFFFFF 0%, #8F3052 30%, #8F3052 70%, #FFFFFF 100%)",
    opacity: 0.5,
  },
  tabTitle: {
    marginLeft: 8,
  },
  tabLabel: {
    display: "flex",
    alignItems: "center",
  },
  subtopicLabel: {
    paddingLeft: theme.spacing(0),
    "& .subtopicTitle": {
      color: theme.palette.text.dark,
      display: "block",
    },
    "&:hover .subtopicTitle": {
      color: theme.palette.Primary.background,
      cursor: "pointer",
      fontWeight: 700,
      fontSize: 14,
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    },
    "&.clicked .subtopicTitle": {
      color: theme.palette.Primary.background,
      fontWeight: 700,
      fontSize: 20,
      whiteSpace: "nowrap",
    },
    "&:not(:hover) .clicked .subtopicTitle": {
      color: theme.palette.text.dark,
    },
    "& span": {
      color: theme.palette.text.dark,
    },
    "&:hover span": {
      color: theme.palette.Primary.background,
      cursor: "pointer",
      fontWeight: 700,
      fontSize: 16,
    },
    "&.clicked span": {
      color: theme.palette.Primary.background,
      fontWeight: 700,
      fontSize: 16,
    },
    "&:not(:hover) .clicked span": {
      color: theme.palette.text.dark,
    },
  },
  tabsContainer: {
    position: "relative",
    backgroundColor: theme.palette.text.grey,
  },
  tabBorder: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "3px",
    backgroundColor: "#5A404E",
  },
  bottomBox: {
    borderBottom: "3px solid #5A404E",
    borderLeft: "3px solid #5A404E",
    borderRight: "3px solid #5A404E",
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
    padding: theme.spacing(1, 5, 3, 5),
  },
  bulkButton: {
    background: theme.palette.Primary.background,
    textTransform: "capitalize",
    whiteSpace: "nowrap",
    margin: "0px 0px 40px 20px",
    fontWeight: 400,
    width: 170,
    height: 42,
    "&:hover": {
      backgroundColor: theme.palette.Primary.hoverButton,
      color: theme.palette.Primary.light,
    },
  },
  topBar: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: "122px",
  },
  info: {
    // paddingTop: theme.spacing(8),
    "& .MuiSvgIcon-root": {
      width: "1.5em",
      // height : '2em'
    },
  },
  infoIcon: {
    fontSize: "larger",
    color: theme.palette.Primary.background,
    cursor: "pointer",
    flexShrink: 0, // ✅ prevents shrinking
    minWidth: "1.2em", // ✅ ensures enough space
  },
  tooltip: {
    cursor: "pointer",
    "& .MuiTooltip-tooltip": {
      backgroundColor: ` ${theme.palette.Primary.light} !important`,
      border: "1px solid #8C2148",
      color: "black",
    },
  },
  tabContentBox: {
    paddingLeft: "15px",
  },
  subtopicTitle: {
    "& .MuiSvgIcon-root": {
      width: "1.5em",
      // height : '2em'
      flexWrap: "nowrap",
    },
  },
  topicsEnv: {
    display: "grid",
    gridTemplateColumns: "30% 70%",
    // padding: theme.spacing(4),
    width: "100%",
    margin: "auto",
  },

  dialogPaper: {
    width: "850px",
    padding: "40px 32px",
    borderRadius: "12px",
    boxShadow: "0px 6px 24px rgba(0,0,0,0.2)",
  },
  dialogTitleText: {
    fontWeight: 600,
    textAlign: "center",
    marginBottom: "24px",
    fontSize: "16px",
  },

  dialogContentGrid: {
    marginTop: "20px",
  },
  closeButton: {
    position: "absolute",
    top: 16,
    right: 16,
    color: "#5a404e",
    zIndex: 1,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },

  dialogTitle: {
    fontWeight: 600,
    textAlign: "center",
    paddingBottom: 0,
  },

  dialogActions: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    gap: theme.spacing(2),
    width: "100%",
  },
  button1: {
    width: "90px",
    fontWeight: 400,
    padding: "8px 0",
    minWidth: "unset",
    backgroundColor: "#881C3A",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#721732",
    },
    fontStyle: "normal",
    fontSize: "13px!important",
  },
  button2: {
    width: "90px",
    fontWeight: 400,
    padding: "8px 0",
    minWidth: "unset",
    fontStyle: "normal",
    fontSize: "13px!important",
    border: "1px solid #881C3A",
    color: "#881C3A",
    backgroundColor: "#fff",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  buttonDisabled: {
    opacity: 0.5,
    pointerEvents: "auto",
    cursor: "not-allowed",
  },

  proceedButton: {
    backgroundColor: "#7f2a47",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#661f39",
    },
  },

  outlinedButton: {
    border: "1px solid #7f2a47",
    color: "#7f2a47",
    backgroundColor: "#fff",
    "&:hover": {
      backgroundColor: "#f7f2f4",
    },
  },
  scopeWrapper: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },

  scopeContainer: {
    backgroundColor: "rgb(185, 181, 181)",
    padding: "10px",
    borderRadius: "8px",
    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.05)",
    minWidth: "260px",
    flex: "1 1 30%",
  },
}));

export default useStyles;
